// src/utils/apiConfig.js

export const API_BASE_URL = "https://restocash.app/api/";
export const API_PASSWORD = "Project102$_";

export const API_BASE_URL_images = "https://restocash.app/";
